export { DialogLectureDelete } from './dialog-lecture-delete';
